'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var assert = require('../utils/assert.cjs');

/**
 * A helper type that defines a model as an opaque type.
 */

/**
 * A helper function that determines whether a value is a model
 * of the given type.
 */
const isModel = (model, value) => typeof value === 'object' && value.model === model;

/**
 * A helper function to use in type guards asserting that a value is a model.
 * This currently wraps the `assert` method which is not exposed by the library.
 * In the future, we might replace this with a custom error.
 */
function assertModel(condition, message) {
  assert["default"](condition, message);
}

exports.assertModel = assertModel;
exports.isModel = isModel;
//# sourceMappingURL=Model.cjs.map
